/**
 * Joins a summary line the way the design writes it: "Active · PR associate · Full time".
 *
 * Falsy parts drop out, so a caller can pass a value it might not have without guarding each one,
 * and a line left with nothing in it is `undefined` rather than empty — a section then renders no
 * subheader at all instead of a blank one.
 */
export const summarize = (...parts: (string | number | null | undefined | false)[]) =>
  parts.filter(Boolean).join(' · ') || undefined;
